import { useEffect, useState } from "react";
import { FormControlElement, IScriptAndStyle } from "../../../models/Interfaces";
import AppModal from "../../components/common/AppModal";
import { Col, FormControl, FormLabel, Row, Spinner } from "react-bootstrap";
import AceEditor from "react-ace";
import 'ace-builds/src-noconflict/ext-command_bar';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/theme-sqlserver';
import { ScriptIncludeType } from "../../../config/Enums";
import FormCheckInput from "react-bootstrap/esm/FormCheckInput";

interface IAddUpdateScriptCss {
  scriptCss: IScriptAndStyle;
  onClose: () => void;
  onSave: (scriptcss: IScriptAndStyle) => void;
  type: ScriptIncludeType;
  saving?: boolean;
}

const AddUpdateScriptCss = (props: IAddUpdateScriptCss) => {
  const [ selectedScript, setSelectedScript ] = useState<IScriptAndStyle>();

  const saveScriptOrCss = () : void => {
    if (selectedScript) {
      props.onSave(selectedScript);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<FormControlElement>) : void => {
    const { value, name } = event.target;

    if (name) {
      setSelectedScript(prev => ({
        ...prev as IScriptAndStyle,
        [name]: value
      }));
    }
  };

  const handleCheckInputChange = (event: React.ChangeEvent<HTMLInputElement>) : void => {
    const { name, checked } = event.target;

    if (name) {
      setSelectedScript(prev => ({
        ...prev as IScriptAndStyle,
        [name]: checked
      }));
    }
  };

  const handleCodeChange = (value: string) : void => {
    setSelectedScript(prev => ({
      ...prev as IScriptAndStyle,
      Code: value
    }));
  };

  const getTitleType = (type: ScriptIncludeType) : string => {
    switch (type) {
      case ScriptIncludeType.Css:
        return "StyleSheet";
      case ScriptIncludeType.ClientScript:
        return "Client Script";
      case ScriptIncludeType.Robots:
        return "Robots Content";
      case ScriptIncludeType.AI:
        return "AI Content";
      default:
        return "";
    }
  };

  useEffect(() => {
    setSelectedScript(props.scriptCss);
  }, [props.scriptCss]);

  return (
    <AppModal
      onClose={() => { if (!props.saving) props.onClose(); }}
      onDataAction={saveScriptOrCss}
      size="xl"
      showButtons={true}
      enableActionButton={!props.saving}
      dataActionButtonText={props.saving ? "Saving…" : `Save ${getTitleType(props.type)}`}
      title={`${getTitleType(props.type)} Details`}>
        <div>
          {props.saving && <div role="status" className="text-secondary mb-2"><Spinner size="sm" aria-hidden="true" /> Saving…</div>}
          <fieldset disabled={props.saving}>
          <Row>
            <Col md={12}>
              <FormLabel htmlFor="Description">Description</FormLabel>
              <FormControl
                type="text"
                name="Description"
                id="Description"
                value={selectedScript?.Description ?? ""}
                onChange={handleInputChange}
                placeholder={`description of ${getTitleType(props.type).toLowerCase()} ...`}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mt-3">
              <FormLabel htmlFor="Code">{`${getTitleType(props.type)} Content`}</FormLabel>
              <AceEditor
                  mode={props.type === ScriptIncludeType.ClientScript ? "javascript" : "css" }
                  theme="sqlserver"
                  name="Code"
                  onChange={handleCodeChange}
                  fontSize={12}
                  value={selectedScript?.Code ?? ""}
                  className="border"
                  setOptions={{
                    enableBasicAutocompletion: true,
                    enableLiveAutocompletion: true,
                    enableSnippets: true,
                    useWorker: false,
                    showPrintMargin: false
                  }}
                  style={{width: '100%', height:'230px'}} />              
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mt-3">
              <FormLabel htmlFor="Url">External URL (if script or stylesheet located on external site)</FormLabel>
              <FormControl
                type="text"
                name="Url"
                id="Url"
                value={selectedScript?.Url ?? ""}
                onChange={handleInputChange}
                placeholder={`location of external ${getTitleType(props.type).toLowerCase()} (optional)...`}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} xl={4} className="mt-3">
              <FormLabel htmlFor="Enabled">Enabled</FormLabel>
              <FormCheckInput 
                className="form-check"
                name="Enabled"
                id="Enabled"
                checked={selectedScript?.Enabled ?? false}
                onChange={handleCheckInputChange}
              />
            </Col>
          </Row>
          </fieldset>
        </div>
    </AppModal>
  )
}

export default AddUpdateScriptCss;